import { cn } from '@/lib/shadcn/utils';
import React, { type FC } from 'react';

type ProcessProps = Readonly<React.HTMLAttributes<HTMLDivElement>> & {
  readonly imageFirst?: boolean;
};

type ProcessColumnProps = Readonly<React.HTMLAttributes<HTMLDivElement>> & {
  readonly imageFirst?: boolean;
};

const ProcessHeader: FC<Readonly<React.HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <section
      className={cn('overflow-hidden bg-[#0A0A0A] py-16 sm:py-16', className)}
      {...props}
    >
      <div className="container px-6 sm:py-8 lg:px-8">{children}</div>
    </section>
  );
};

const Process: FC<ProcessProps> = ({ className, children, ...props }) => {
  return (
    <div
      className={cn(
        'lg:flex lg:justify-between lg:items-center py-16',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

const ProcessColumn: FC<ProcessColumnProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={cn('lg:pr-8', className)} {...props}>
      <div className="pb-16 lg:max-w-lg">{children}</div>
    </div>
  );
};

const ProcessHeading: FC<
  Readonly<React.HTMLAttributes<HTMLParagraphElement>>
> = ({ className, ...props }) => {
  return (
    <p
      className={cn(
        'text-4xl font-semibold tracking-tight text-white sm:text-5xl',
        className
      )}
      {...props}
    />
  );
};

function ProcessDescription({
  className,
  ...props
}: Readonly<React.HTMLAttributes<HTMLParagraphElement>>) {
  return (
    <p className={cn('mt-6 text-lg text-white/60', className)} {...props} />
  );
}

export {
  Process,
  ProcessColumn,
  ProcessDescription,
  ProcessHeading,
  ProcessHeader,
};
